import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconSandboxPlayground = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M18.6689 4.26777L11.3656 11.5711L9.42101 9.62652C8.54233 8.74784 7.11771 8.74784 6.23903 9.62652L3.76415 12.1014C1.51864 14.3469 1.51864 17.9876 3.76415 20.2331C6.00967 22.4786 9.65037 22.4786 11.8959 20.2331L14.3708 17.7583C15.2494 16.8796 15.2494 15.455 14.3708 14.5763L12.4262 12.6317L19.7295 5.32843L20.9669 6.56586C21.2598 6.85876 21.7347 6.85876 22.0276 6.56586C22.3205 6.27297 22.3205 5.7981 22.0276 5.5052L18.4921 1.96967C18.1992 1.67678 17.7243 1.67678 17.4314 1.96967C17.1385 2.26256 17.1385 2.73744 17.4314 3.03033L18.6689 4.26777ZM8.00679 14.9298L10.3049 12.6317L8.36035 10.6872C8.06745 10.3943 7.59258 10.3943 7.29969 10.6872L4.82481 13.1621C3.16508 14.8218 3.16508 17.5127 4.82481 19.1725C6.48454 20.8322 9.17549 20.8322 10.8352 19.1725L13.3101 16.6976C13.603 16.4047 13.603 15.9298 13.3101 15.6369L11.3656 13.6924L9.06745 15.9905C8.77456 16.2834 8.29969 16.2834 8.00679 15.9905C7.7139 15.6976 7.7139 15.2227 8.00679 14.9298Z",
		fill: "currentColor"
	})
});
export { SvgIconSandboxPlayground as ReactComponent };
